import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { GlobalConstants } from '@environments/global-Variables';
import { Column } from '@shared/models/column-interface';

@Component({
  selector: 'weaccess-table',
  templateUrl: './table.component.html',
  styleUrls: ['./table.component.scss']
})
export class TableComponent<T> implements OnInit {

  globalConstants = GlobalConstants;

  @Input()
  tableColumns: Array<Column> = [];

  @Input()
  tableData: Array<T> = [];

  @Input()
  tableId: any;

  className!: string;

  @ViewChild('tableSort') tableSort = new MatSort();

  displayedColumns: Array<string> = [];
  dataSource: MatTableDataSource<T> = new MatTableDataSource();

  constructor() { }

  ngOnInit(): void {
    this.displayedColumns = this.tableColumns.map((c) => c.columnDef);
    this.dataSource = new MatTableDataSource(this.tableData);
  }

  /** Track by function for ngFor in column iteration */
  trackByFn(index: number, disCol: any): number {
    return disCol.id;
  }

  /**Listen event for data changes */
  ngOnChanges() {
    this.displayedColumns = this.tableColumns.map((c) => c.columnDef);
    this.dataSource = new MatTableDataSource(this.tableData);
    this.dataSource.sort = this.tableSort;
  }

  /**After view loaded apply sort and clear functionlity */
  ngAfterViewInit() {
    this.tableSort.disableClear = true;
    this.dataSource.sort = this.tableSort;
  }
  checkEvent() {
  }

  /**Getting class for color differentiation based on request status */
  getClass(element: any) {
    this.className = ''
    switch (element) {
      case 'Approved':
        this.className = "text-green";
        break;
      case 'Pending':
        this.className = "text-orange";
        break;
      case 'Suspend':
        this.className = "text-grey";
        break;
      case 'Reject':
        this.className = "text-red";
        break;
      default:
        this.className = ''
    }
    return this.className
  }
}

export interface TableRecord {

}
